module.exports = __webpack_public_path__ + "assets/815a557fa644dab0dc51bd8f5577c706.png";